import { useEffect, useState } from "react";
import { AutoComplete } from "@/core/components/ui/autocomplete";
import {
  ROLE_OPTIONS,
  ROLE_TO_LABEL,
  ROLE_TO_ACCESS_DESCRIPTION,
} from "@/user/constants";
import { Stack } from "./ui/stack/stack";
import { Typography } from "./ui/typography";

interface RoleSelectorProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  fullWidth?: boolean;
  required?: boolean;
  exclude?: string[];
  disabled?: boolean;
  disabledTooltip?: React.ReactNode | string;
}

export const RoleSelector = ({
  value,
  onChange,
  label = "Role",
  placeholder = "Select a role",
  fullWidth = false,
  required = false,
  exclude = [],
  disabled = false,
  disabledTooltip,
}: RoleSelectorProps) => {
  const [roleSearch, setRoleSearch] = useState("");

  useEffect(() => {
    setRoleSearch(ROLE_TO_LABEL[value as keyof typeof ROLE_TO_LABEL] || "");
  }, [value]);

  const renderRoleOption = (option: { value: string; label: string }) => (
    <Stack gap="sm">
      <Typography variant="bodyW2" className="font-medium">
        {option.label}
      </Typography>
      <Typography variant="captionW1" textColor="tertiary">
        {
          ROLE_TO_ACCESS_DESCRIPTION[
            option.value as keyof typeof ROLE_TO_ACCESS_DESCRIPTION
          ]
        }
      </Typography>
    </Stack>
  );

  return (
    <Stack gap="none" fullWidth={fullWidth}>
      <AutoComplete
        label={label}
        selectedValue={value}
        onSelectedValueChange={onChange}
        searchValue={roleSearch}
        onSearchValueChange={setRoleSearch}
        items={ROLE_OPTIONS.filter(
          (option) =>
            !exclude.includes(option.value) &&
            option.label.toLowerCase().includes(roleSearch.toLowerCase()),
        )}
        renderOption={renderRoleOption}
        emptyMessage="No roles found"
        placeholder={placeholder}
        required={required}
        fullWidth={fullWidth}
        disabled={disabled}
        disabledTooltip={disabledTooltip}
      />
      <Typography className="h-10" variant="captionW1" textColor="tertiary">
        {
          ROLE_TO_ACCESS_DESCRIPTION[
            value as keyof typeof ROLE_TO_ACCESS_DESCRIPTION
          ]
        }
      </Typography>
    </Stack>
  );
};
